<div style="padding-bottom:20px">

<div *ngIf="this.activeMapToEdit == null">
  


  <div class="row" style="margin-bottom:15px">
    <div class="col-sm-6"> 
   
      <!-- 
   <div class="col-sm-12 searchControls">
    
    <div class='gridCell'> 

        <div> 
          <label for="">Lectionary Year</label>
          <select [(ngModel)]="filterModel.Year">
              <option>A</option> 
              <option>B</option> 
              <option>C</option> 
              <option>1</option> 
              <option>2</option> 
          </select> 
        </div>

    </div>
 
    <div class='gridCell'>
      <label for="">Date</label>
      <div><input type="date" [(ngModel)]="filterModel.Date"/></div>
    </div> 

  </div> 
 -->

  </div>

    <div class="col-sm-6 text-right">
        <button *ngIf="isServiceUsingProperMap == false" class="btn btn-sm btn-outline-secondary float-right"  (click)="addMapping()">
            <i  class="fa fa-plus mr-5"></i>Add Map
          </button>
    </div>

  </div>

   
  <div *ngIf="isLoading == false">
 
       <div *ngIf="isServiceUsingProperMap == true && mappings != null && mappings.length > 0" class="properMappingsWarning">
           This Service has mappings bit it also has "Use Proper Map" = true. Please delete these mappings and edit mappings using Admin - Propers.
       </div>

      <div class="table-responsive table tblGrid" [ngClass]="{'properGrid': isProper == true}">
 
        <div class="xrow header gridRow row">
          <!-- <div>Id</div> -->
          <div>Liturgy Type</div>
          <div>Type</div>
          <div>Year</div> 
          <div class='track'>Track</div> 
          <div>Name</div>
          <div>Map Source</div>
          <div></div>
        </div>
  
        <div *ngFor="let m of mappings" class="xrow dateRow gridRow row">
            <!-- <div>{{m.Id}}</div> -->
            <div>{{m.LiturgyType?.Localized[0].Name}}</div> 
            <div>
              {{m.LectionaryItemType?.Localized[0].Name}}<span *ngIf="m.LectionaryItemTypeSubType != null">, {{m.LectionaryItemTypeSubType.Localized[0].Name}}</span>
            </div>  
            <div>{{m.LectionaryYear?.Localized[0].Name}}</div> 
            <div class='track'>{{m.LectionaryTrack?.Localized[0].Name}}</div>  
            <div>{{m.LectionaryItemName.Localized[0].Name}}</div>
            <div>
                {{m.LectionarySource?.NameAbbreviated}} 
                <span *ngIf="m.LectionarySourcePageNumber != '' && m.LectionarySourcePageNumber != null">p. {{m.LectionarySourcePageNumber}}</span>
            </div>
            <div>

              <button type="button" class="btn btn-sm btn-secondary js-tooltip-enabled" style="margin-right: 4px;" data-toggle="tooltip" title="" data-original-title="Edit" (click)="editMapping(m)">
                <i class="fa fa-pencil"></i>
              </button>
              <button type="button" class="btn btn-sm btn-secondary js-tooltip-enabled" data-toggle="tooltip" title="" data-original-title="Delete" (click)="deleteMapping(m)">
                <i class="fa fa-times"></i>
              </button>

            </div> 
        </div>
 
      </div>

  </div>
  
  <app-progress-bar *ngIf="isLoading==true"></app-progress-bar>


</div>

<div *ngIf="activeMapToEdit != null"> 
  <app-mappings-edit [map]="activeMapToEdit" [isProper]="isProper" (closed)="editMappingClosed()" ></app-mappings-edit>
</div>
</div>